import { useTranslate } from "ra-core";
import { Link, matchPath, useLocation } from "react-router";
import { cn } from "@/lib/utils";

/**
 * «Клиенты» is one menu item with two tabs: people (contacts) and companies.
 * The tabs link to the existing /contacts and /companies routes.
 */
export const ClientsTabs = ({ className }: { className?: string }) => {
  const translate = useTranslate();
  const location = useLocation();
  const onCompanies = !!matchPath("/companies/*", location.pathname);
  const tabs = [
    { to: "/contacts", label: "crm.clients.people", active: !onCompanies },
    { to: "/companies", label: "crm.clients.companies", active: onCompanies },
  ];

  return (
    <nav
      aria-label={translate("crm.clients.tabs_label")}
      className={cn("flex gap-1 rounded-lg bg-muted p-1 w-fit", className)}
    >
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          aria-current={tab.active ? "page" : undefined}
          className={cn(
            "rounded-md px-4 py-1.5 text-sm font-medium transition-colors",
            tab.active
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {translate(tab.label)}
        </Link>
      ))}
    </nav>
  );
};
